import React, {useEffect, useState} from 'react';
import AppBar from "../../Components/AppBar";
import {Container} from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import makeStyles from "@material-ui/core/styles/makeStyles";
import {useRouteMatch} from "react-router";
import Box from "@material-ui/core/Box";
import {callAPI} from "../../../../lib/common";
import PickupLocation from "./Components/PickupLocation";
import {Trans, useTranslation} from "react-i18next";

const useStyles = makeStyles(theme => ({
  section: {
    textAlign: 'center'
  },
  deliveryBox: {
    backgroundColor: '#E0E0E0',
    textAlign: 'left'
  },
  address: {
    listStyle: 'none',
    padding: 0,
    margin: 0
  }
}));


export default () => {
  const classes = useStyles();
  const match = useRouteMatch();
  const [orderInfo, setOrderInfo] = useState(null);

  useEffect(() => {
    callAPI(`/m/api/order/${match.params.orderUuid}/receipt`)
        .then( (orderInfo) => {
            setOrderInfo(orderInfo);
        })
  }, [])

  if (!orderInfo) {
    return <div>Loading</div>
  }

  console.log('OrderInfo', orderInfo);

  return  <React.Fragment>
    <AppBar disableGutters />
    <div className={classes.section}>
      <Container maxWidth="sm">
        <Box mt={4} mb={4}>
          <Typography variant="h4">
            <Trans>Thank you for your order</Trans>
          </Typography>
        </Box>
        <p>
          <Trans>The order is registered in our system with the following reference number:</Trans>
        </p>
        <p><b>{match.params.orderUuid.substring(0,8)}</b></p>
        <p>{orderInfo.payment.infoText}</p>
      </Container>
      <DeliveryInfo delivery={orderInfo.delivery}/>
    </div>
  </React.Fragment>
}

const DeliveryInfo = ({delivery}) => {
  const classes = useStyles();
  console.log('Delivery', delivery, delivery.type, typeof(delivery.type))
  return <Container  maxWidth='sm'>
    <Container className={classes.deliveryBox}>
      <Box pt={2} pb={2}>
        {delivery.type === 0 ? <PickupInfo delivery={delivery} /> : <ShippingInfo delivery={delivery} />}
      </Box>
    </Container>
  </Container>
}

const PickupInfo = ({delivery}) => {
  const classes = useStyles();
  const pickupLocation = delivery.pickupLocation;
  const {t} = useTranslation();

  return <>
    <Typography variant="h4">
      <Trans>Pickup in store</Trans>
    </Typography>
    <p>
      {t('You have chosen to pick up the order in our store. The chosen delivery time is %s, but please remember to take our opening hours into account.',
        { postProcess: 'sprintf', sprintf: [ delivery.deliveryTimeString ] })}
    </p>
    <p><Trans>Order is to be picked up at our store:</Trans></p>
    <ul className={classes.address}>
      <li><b>{pickupLocation.name}</b></li>
      <li>{pickupLocation.address}</li>
      <li>{pickupLocation.postalCode} {pickupLocation.city}</li>
    </ul>
  </>
}


const ShippingInfo = ({delivery}) => {
  const classes = useStyles();
  const address = delivery.address;
  const {t} = useTranslation();

  return <>
    <Typography variant="h4">
      <Trans>Mail order</Trans>
    </Typography>
    <p>
      <Trans>You have chosen to have the order delivered to you by mail.</Trans>
    </p>

    <p>
      {t('Normal delivery time is within %s, and the order will be sent to:',  { postProcess: 'sprintf', sprintf: [ delivery.deliveryTimeString ] })}
    </p>

    <ul className={classes.address}>
      <li><b>{address.name}</b></li>
      <li>{address.address}</li>
      <li>{address.postalCode} {address.city}</li>
    </ul>
  </>
}